<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-offset-3 col-xs-6">
      <h3 class="text-center">Home</h3>
      <p class="text-center">Navigate using the black pane to the left or use the quick table search below</p>
      <input class="form-control" placeholder="Begin typing table name..." v-model="searchQuery" autofocus/>
        <div v-bind:class="{ 'table-container': tables.length > 5, 'research-container': tables.length < 6 }">
          <br />
           
           
          <ul class="list-group">
            <div v-for="table in filter()">           
            <li v-if="((onlycontacts && table.name != 'contact_information') || !onlycontacts)" >
             {{ readableTableName(table) }}
            <div class="btn-group pull-right">
             
              <router-link v-if="table.permissions.includes('SELECT') && !table.name.includes('workflow') && !hiddenEditTables.includes(table.name)" :to="`/tables/${table.name}`"><button type="button" class="btn btn-sm btn-primary btn-option">Edit</button></router-link>
              <router-link v-if="table.permissions.includes('INSERT') && (table.name !== 'files' && table.name !== 'submitted_photos_staging')" :to="`/add/${table.name}`"><button type="button" class="btn btn-sm btn-primary btn-option">Add</button></router-link>
            </div>
            <hr />
            </li>
            </div>
            <li v-if="roles.includes('writer') || roles.includes('admin')">
              Election Night Processing <div class="brn-group pull-right"><router-link :to="`/multiTable/election_night_processing`"><button type="button" class="btn btn-sm btn-primary btn-option">Edit</button></router-link></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import readableName from '../mixins/readableName'
export default {
  name: 'Home',
  props: ["tables"],
  mixins: [readableName],
  methods: {
    filter() {
      let filteredTables = [];
      this.tables.forEach((table) => {
        let readAbleTable = this.readableTableName(table);
        if(readAbleTable.toLowerCase().includes(this.searchQuery.toLowerCase())) {
          filteredTables.push(table);
        }
      })

      return filteredTables;
    },
    getonlycontacts(roles){
      if (roles.split(',').length == 1 && roles.includes('contact_information_contractor')){
         return true
     } else {
      return false
     }            
    },
    /**
     * Returns array of table names, which won't have the "Edit" button appear in the list of tables
     * This is typically done to hide certain views from non-staff users
     * @param {string[]} roles 
     * @returns {string[]}
     */
    getHiddenEditTables(roles) {
      if (roles.includes('local_candidate_endorsements_volunteer')) {
        // table shows because role has SELECT, but we want to simplify table list for volunteers
        return ['candidate_endorsements_staging'];
      }
      return [];
    }
  },
  data: function() {
    return {
      searchQuery: '',
      filteredTables: [],
      roles: localStorage.getItem("roles"),
      onlycontacts:  this.getonlycontacts(localStorage.getItem("roles")),
      hiddenEditTables: this.getHiddenEditTables(localStorage.getItem("roles")),
  }
  }
}

</script>

<style scoped>

h2 {
  text-align: center;
}


li {
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 10px;
}

.table-container {
 height: 500px;
 overflow-y: scroll;
}
.research-container {
 overflow-y: auto;
}

</style>
